import {BlockType, Blocks} from '../blocks/Blocks'
import {
	Contentside,
	ContentsideContent,
	ContentsideSidebar
} from '../layout/Contentside'
import {Hero, HeroSide, HeroType} from '../layout/Hero'
import {SidebarBlockType, SidebarBlocks} from '../sidebar/SidebarBlocks'

import {Breadcrumbs} from '../layout/Breadcrumbs'
import {Layout} from '../layout/Layout'
import {PageData} from '../../types'
import React from 'react'
import {RelatedEvents} from '../layout/RelatedEvents'
import {TeamsInfo} from './teams/TeamsInfo'
import {getUrlByKey} from '../../util/nav'
import {style} from '../../util/style'
import {wrap} from '@codeurs/front'

const styles = style('event')

type EventType = {
	hero: HeroType
	contentblocks?: Array<BlockType>
	sidebarblocks?: Array<SidebarBlockType>
	blocks?: Array<BlockType>
	currentYear?: string
	moneyGathered?: string
	numberOfTeams?: number
}

export const Event: React.FC<PageData & EventType> = wrap(Layout)(
	({...props}) => {
		const {
			parents,
			title,
			hero,
			contentblocks,
			sidebarblocks,
			blocks,
			related_project,
			related_events,
			main_pages: nav,
			currentYear,
			moneyGathered,
			numberOfTeams
		} = props
		const hasContentside =
			(hero && !hero?.image) ||
			(contentblocks && contentblocks.length > 0) ||
			(sidebarblocks && sidebarblocks.length > 0)
		const eventsLink = getUrlByKey(nav, 'events')

		return (
			<div className={styles()}>
				{hero?.image && (
					<Hero {...hero} title={(hero && hero.title) || title} />
				)}
				<Breadcrumbs parents={parents} title={title} />
				{moneyGathered && currentYear && numberOfTeams ? (
					<TeamsInfo
						money={moneyGathered}
						message={`werd reeds ingezameld voor de editie van ${currentYear} dankzij de ${numberOfTeams} deelnemende teams.`}
					/>
				) : null}
				{hasContentside && (
					<Contentside>
						<ContentsideContent>
							{(!hero || !hero?.image) && (
								<HeroSide {...hero} title={hero?.title || title} />
							)}
							<Blocks blocks={contentblocks} />
						</ContentsideContent>
						<ContentsideSidebar>
							<SidebarBlocks blocks={sidebarblocks} />
						</ContentsideSidebar>
					</Contentside>
				)}
				<Blocks blocks={blocks} container={true} />
				<RelatedEvents
					linkToEventspage={eventsLink?.url}
					project={related_project}
					events={related_events}
				/>
			</div>
		)
	}
)
